import * as React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { useState } from "react";
import { Modal } from "../../components/Modal";
import "./style.css";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { useMediaQuery } from "react-responsive";
import { CustomMasonry } from "../../components/Masonry";
import { ModalContent } from "../ModalContent";
import ElementFadeIn from "../ElementFadeIn";
import { Skeleton } from "@mui/material";
import Masonry from "react-masonry-css";

const ArtCollection = (props) => {
    const { page, title, subtitle, photos, enableFavourite, noRecordFound } = props;
    const [openImageModal, setOpenImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [displayImages, setDisplayImages] = useState(false);
    const [displayModalContent, setDisplayModalContent] = useState(false);

    const isDesktop = useMediaQuery({ minWidth: 1180 });
    const md = useMediaQuery({ maxWidth: 900, minWidth: 768 });
    const sm = useMediaQuery({ maxWidth: 767 });

    React.useEffect(() => {
        setDisplayImages(true);
    }, []);

    const handleImageDetails = (item) => {
        setSelectedImage(item);
        if (enableFavourite) {
            props.onClick(item);
            setOpenImageModal(false);
        } else {
            setOpenImageModal(true);
        }

        //enableFavourite ? setOpenImageModal(false) : setOpenImageModal(true);
        setTimeout(() => {
            setDisplayModalContent(true);
        }, 100);
    };

    const handleCloseModal = (value) => {
        setDisplayModalContent(false);
        setTimeout(() => {
            setOpenImageModal(false);
        }, 100);
    };
    const breakpointColumnsObj = {
        default: 3,
        1100: 3,
        700: 2,
        500: 1,
    };

    return (
        <Paper
            sx={{
                position: "relative",
                backgroundColor: enableFavourite ? "#303030" : "#000",
                color: "#fff",
                px: enableFavourite ? 6 : 0,
                mb: 4,
                mt: page === "Student" ? 10 : 0,
                height: "100%",
                zIndex: 1,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                maxWidth: "1200px",
                margin: page === "Corporate" ? (isDesktop ? "0px auto" : "100px auto") : "80px auto",
                marginBottom: "32px",
            }}
            elevation={0}>
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    backgroundColor: enableFavourite ? "#303030" : "rgba(0,0,0,.3)",
                }}
            />
            <Grid container>
                <Grid item md={12}>
                    <Box
                        sx={{
                            position: "relative",
                            pt: enableFavourite ? { xs: 0, lg: 0 } : { xs: 3, lg: 6 },
                            pr: { xs: 3, lg: 0 },
                            pl: { xs: 3, lg: 0 },
                            paddingBottom: "6rem",
                        }}>
                        {enableFavourite ? (
                            <></>
                        ) : (
                            <>
                                <h1 className={`fade-in ${displayImages ? "show" : ""}`}>{title}</h1>

                                <p className={`h3 fade-in-2 ${displayImages ? "show" : ""}`}>{subtitle}</p>
                            </>
                        )}
                        {noRecordFound && (
                            <Box>
                                <h4
                                    style={{
                                        width: "100%",
                                        color: "white",
                                        fontSize: "1.2rem",
                                        textAlign: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "300px",
                                    }}>
                                    {page === "Student"
                                        ? "No record found. Please try another filter"
                                        : "No record found."}
                                </h4>
                            </Box>
                        )}
                        {!noRecordFound && (
                            <>
                                {photos?.length > 0 ? (
                                    <CustomMasonry
                                        page={page}
                                        photos={photos}
                                        selectedImage={handleImageDetails}
                                        openModal={handleCloseModal}
                                        onDelete={props.onDelete}
                                        enableFavourite={enableFavourite}></CustomMasonry>
                                ) : (
                                    <ElementFadeIn>
                                        <Box
                                            sx={{
                                                width: "100%",
                                                top: 0,
                                                left: 0,
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                            }}>
                                            <Masonry
                                                style={{ marginTop: "18px", opacity: displayImages ? 1 : 0 }}
                                                breakpointCols={breakpointColumnsObj}
                                                className="my-masonry-grid"
                                                columnClassName="my-masonry-grid_column">
                                                <Skeleton
                                                    variant="rectangular"
                                                    width={"100%"}
                                                    height={md ? 300 : sm ? 200 : 400}
                                                    sx={{ backgroundColor: "#3e3e3e", mt: "10px" }}
                                                />
                                                <Skeleton
                                                    variant="rectangular"
                                                    width={"100%"}
                                                    height={md ? 250 : sm ? 170 : 300}
                                                    sx={{ backgroundColor: "#3e3e3e", mt: "10px" }}
                                                />
                                                <Skeleton
                                                    variant="rectangular"
                                                    width={"100%"}
                                                    height={md ? 325 : sm ? 230 : 450}
                                                    sx={{ backgroundColor: "#3e3e3e", mt: "10px" }}
                                                />
                                            </Masonry>
                                        </Box>
                                    </ElementFadeIn>
                                )}
                            </>
                        )}

                        {openImageModal && (
                            <ModalContent
                                openModal={handleCloseModal}
                                open={openImageModal}
                                selectedImage={selectedImage}
                                title={
                                    page === "Student" ? (
                                        <div>
                                            <div
                                                className={`margin-xs modal-fade-in-2 ${
                                                    displayModalContent ? "show" : ""
                                                }`}>
                                                {selectedImage?.artists.map((item) => (
                                                    <div className="h3 font-rb-stakkat italicize modal-text-1">
                                                        {item?.name}
                                                    </div>
                                                ))}
                                            </div>
                                            {selectedImage?.grade && (
                                                <div
                                                    className={`margin-m modal-text-2 modal-fade-in-3 ${
                                                        displayModalContent ? "show" : ""
                                                    }`}>
                                                    <div className="text-xl inline-text">
                                                        Grade {selectedImage?.grade}{" "}
                                                        {selectedImage?.licenseYear
                                                            ? `/ Year ${selectedImage?.licenseYear}`
                                                            : ""}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ) : page === "Corporate" ? (
                                        <div>
                                            {selectedImage?.companyName && (
                                                <div
                                                    className={`margin-m modal-fade-in-4 ${
                                                        displayModalContent ? "show" : ""
                                                    }`}>
                                                    <span className="text-l modal-text-3">Installed for :</span>
                                                    <div className="h3 font-rb-stakkat italicize modal-text-1">
                                                        {selectedImage?.companyName}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <></>
                                    )
                                }
                                subtitle={
                                    page === "Student" ? (
                                        <Box>
                                            <div
                                                className={`margin-m modal-fade-in-4 ${
                                                    displayModalContent ? "show" : ""
                                                }`}>
                                                {selectedImage?.style?.map((item) => {
                                                    return <span className="text-l modal-text-3">#{item} </span>;
                                                })}
                                                {selectedImage?.color?.map((item) => {
                                                    return <span className="text-l modal-text-3">#{item} </span>;
                                                })}
                                                {selectedImage?.keyword?.map((item) => {
                                                    return <span className="text-l modal-text-3">#{item} </span>;
                                                })}
                                            </div>
                                            <div
                                                className={`margin-m modal-text-2 modal-fade-in-3 ${
                                                    displayModalContent ? "show" : ""
                                                }`}>
                                                <div
                                                    className="text-xl inline-text"
                                                    style={{ fontWeight: "600", fontSize: "1.3rem" }}>
                                                    {selectedImage?.title}
                                                </div>
                                            </div>
                                        </Box>
                                    ) : (
                                        <></>
                                    )
                                }></ModalContent>
                        )}
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

export { ArtCollection };
